<template>
    <div>
      <!--General Top Bar -->
      <!-- <general-top-bar :title="$t('marketingFidelities.loyalityPoint')"></general-top-bar> -->
      <!--End General Top Bar -->
      <form>
        <div class="sticky-header" style="margin-top: 20px;">
          <div class="top-bar">
            <div class="form-group">
              <label>{{$t('settingsRewards.state')}}</label>
              <p-switch v-model="model.loyalty_in_use" type="success" @input="handleActive($event)"></p-switch>
            </div>
            <p v-if="model.loyalty_in_use" class="d-inline-flex">
              <button type="submit" class="btn btn-success btn-icon mar-rt-10 save"  @click.prevent="validate" :title="$t('general.save') + ' ' + $t('settingUsers.single')">
                <img src="/static/img/icons/save.png">
                {{$t('general.save')}}
              </button>
            </p>
          </div>
        </div>
        <div class="row mar-to-25">
          <div class="col-md-12 ">
            <div v-if="model.loyalty_in_use" class="row">
              <div class="col-md-4">
                <div class="card">
                  <div class="card-content">
                    <div class="form-group">
                      <label>{{$t('settingsRewards.moneySpent')}}</label>
                      <br/>
                      1 {{currency}} = <input type="number"
                            min="1"
                            step="0.1"
                            name="loyalty_value_one_currency"
                            v-validate="modelValidations.loyalty_value_one_currency"
                            v-model="model.loyalty_value_one_currency"
                            class="form-control in-inline"> {{$t('settingsRewards.plural')}}
                      <span class="help-block">{{$t('settingsRewards.numberOfcurrencyNeedToSpend', {currency: currency})}}</span>
                      <small class="text-danger"  v-if="errors.has('loyalty_value_one_currency')">
                        {{ getError('loyalty_value_one_currency') }}
                      </small>
                    </div>
                    <div class="form-group">
                      <label>{{$t('settingsRewards.pointsTo')}}</label>
                      <br/>
                      <input type="number"
                            min="1"
                            default="1"
                            step="0.1"
                            name="loyalty_value_one_point_amount"
                            v-validate="modelValidations.loyalty_value_one_point_amount"
                            v-model="model.loyalty_value_one_point_amount"
                            class="form-control in-inline">
                      {{$t('settingsRewards.points')}} = <input type="number"
                            min="0"
                            default="1"
                            step="0.1"
                            name="loyalty_value_one_point"
                            v-validate="modelValidations.loyalty_value_one_point"
                            v-model="model.loyalty_value_one_point"
                            class="form-control in-inline"> {{currency}}
                      <span class="help-block">{{$t('settingsRewards.numberOfpointsToReward')}}</span>
                      <small class="text-danger" v-if="errors.has('loyalty_value_one_point')">
                        {{ getError('loyalty_value_one_point') }}
                      </small>
                    </div>
                    <div class="form-group">
                      <label>{{$t('settingsRewards.loyaltyOnlyFullPoints')}}</label>
                      <p-switch v-model="model.loyalty_only_full_points" type="success"></p-switch>
                      <span class="help-block">{{$t('settingsRewards.loyaltyOnlyFullPointsHelp')}}</span>
                    </div>
                    <div class="form-group">
                      <label>{{$t('settingsRewards.loyaltyMinOrderValue')}}<span v-if="currency"> ({{currency}})</span></label>
                      <input
                        type="number"
                        min="0"
                        step="0.01"
                        name="loyalty_min_order_value"
                        v-validate="modelValidations.loyalty_min_order_value"
                        v-model.number="model.loyalty_min_order_value"
                        class="form-control">
                      <span class="help-block">{{$t('settingsRewards.loyaltyMinOrderValueHelp')}}</span>
                      <small class="text-danger" v-if="errors.has('loyalty_min_order_value')">
                        {{ getError('loyalty_min_order_value') }}
                      </small>
                    </div>
                    <div class="form-group">
                      <label>{{$t('settingsRewards.enableNotifications')}}</label>
                      <p-switch v-model="model.enable_notification_loyalty_points" type="success" @input="handleNotification($event)"></p-switch>
                      <span class="help-block">{{$t('settingsRewards.notifyUsersLoyaltyPoints')}} {{ $t('settingsRewards.customizeLoyaltyPointsNotification') }} <a href="#" @click.prevent="goToSettings()">{{ $t('settingsRewards.here') }}. </a></span>
                    </div>

                    <div class="form-group">
                      <label>{{$t('settingCompany.donationPointValue')}}</label>
                      <input
                        type="number"
                        :placeholder="$t('settingCompany.donationPointValueNr')"
                        class="form-control"
                        step="0.1"
                        v-model="model.donation_point_value">
                    </div>
                    <div class="form-group">
                      <label>{{$t('settingsRewards.loyaltyPointsAppLimit')}}</label>
                      <input
                        type="number"
                        min="0"
                        step="1"
                        class="form-control"
                        v-model.number="model.loyalty_points_use_limit">
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-8">
                <div class="card moneyPoints">
                  <div class="card-content">
                    <div class="form-group">
                      <label>{{$t('settingsRewards.moneySpent')}}</label>
                      <div class="days">
                        <div class="day" v-for="(day, deyName) in arrayWithDays">
                          <span :ref="deyName" class="label" :name="deyName">{{$t('daysShort')[deyName]}}</span>
                          <p-checkbox
                            @input="clickOnCheckbox(deyName)"
                            :key="deyName"
                            v-model="arrayWithDays[deyName]"
                          >
                          </p-checkbox>
                          <span v-if="day" class="dayField">
                            1 {{currency}} = <input type="number"
                                                    min="1"
                                                    step="0.1"
                                                    name="loyalty_value_one_currency_per_days"
                                                    v-validate="modelValidations.loyalty_value_one_currency_per_days"
                                                    v-model="model.loyalty_value_one_currency_per_days[deyName].val"
                                                    class="form-control in-inline"> {{$t('settingsRewards.plural')}}
                          </span>
                          <span v-if="day"
                                class="dayField">
                            {{$t('settingsRewards.timeInterval')}}
                          </span>
                          <p-checkbox
                            v-if="day"
                            @input="setTimePeriod(deyName)"
                            v-model="arrayWithDaysTime[deyName]"
                            :key="deyName+'_time'"
                          >
                          </p-checkbox>
                          <span v-if="arrayWithDaysTime[deyName]"
                                class="dayField">
                            {{$t('settingsRewards.fromTime')}}
                          </span>
                          <el-time-select
                            v-if="arrayWithDaysTime[deyName]"
                            placeholder="Select time"
                            class="in-inline-160"
                            :key="timePickerKey[deyName].from"
                            @input="changeFrom"
                            :picker-options="{
                              start: '00:00',
                              step: '00:15',
                              end: '24:00'
                            }"
                            v-model="model.loyalty_value_one_currency_per_days[deyName].from">

                          </el-time-select>
                          <span v-if="arrayWithDaysTime[deyName]"
                                class="dayField">
                            {{$t('settingsRewards.toTime')}}
                          </span>
                          <el-time-select
                            v-if="arrayWithDaysTime[deyName]"
                            placeholder="Select time"
                            class="in-inline-160"
                            @input="changeFrom"
                            :picker-options="{
                              start: '00:00',
                              step: '00:15',
                              end: '24:00'
                            }"
                            v-model="model.loyalty_value_one_currency_per_days[deyName].to">

                          </el-time-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group" v-if="referalModel.is_loyalty">
                <label>Modul recomandari</label>
                <!-- <br/> -->
                <p-switch v-model="referalModel.is_active" type="success" :disabled="!referalModel.is_loyalty" @input="handleActiveReferal($event)"></p-switch>
              </div>
              <div v-if="referalModel.is_active" class="form-group">
                <div class="col-md-12">
                  <div class="form-group ">
                    <label>{{$t('referalSettings.parent_receive_points')}}</label>
                    <p-switch v-model="referalModel.parent_receive" type="success"></p-switch>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label>{{$t('settingsRewards.initialReferal')}}</label>

                    <br/>
                    <label>{{$t('referalSettings.initial_parent_percentage')}}</label> = <input type="number"
                          min="1"
                          step="0.1"
                          name="default_parent_referal_value"
                          v-validate="modelValidations.default_parent_referal_value"
                          v-model="referalModel.default_parent_referal_value"
                          class="form-control in-inline">
                  </div>

                  <div class="form-group">
                    <label>{{$t('referalSettings.initial_child_percentage')}}</label> = <input type="number"
                          min="1"
                          step="0.1"
                          name="default_child_referal_value"
                          v-validate="modelValidations.default_child_referal_value"
                          v-model="referalModel.default_child_referal_value"
                          class="form-control in-inline">
                  </div>
                  <div class="form-group">
                    <label>{{$t('referalSettings.order_count')}}</label> = <input type="number"
                          step="1"
                          name="referal_iterations"
                          v-model="referalModel.referal_iterations"
                          class="form-control in-inline">
                    <span class="help-block">{{$t('referalSettings.order_count_info')}}</span>
                  </div>
                  <div class="form-group">
                    <label>{{$t('referalSettings.order_values')}}</label>

                    <br/>
                    <label>{{$t('referalSettings.parent_order_percentage')}}</label> = <input type="number"
                          min="0"
                          step="0.1"
                          name="referal_iteration_parent_value"
                          v-model="referalModel.referal_iteration_parent_value"
                          class="form-control in-inline">
                  </div>

                  <div class="form-group">
                    <label>{{$t('referalSettings.child_order_percentage')}}</label> = <input type="number"
                          min="0"
                          step="0.1"
                          name="referal_iteration_child_value"
                          v-model="referalModel.referal_iteration_child_value"
                          class="form-control in-inline">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
</template>
<script>
  import Vue from 'vue'
  import {Input, Button, Select, TimePicker} from 'element-ui'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'

  Vue.use(Button)
  Vue.use(Input)
  Vue.use(Select)

  export default {
    components: {
      [Button.name]: Button,
      [Input.name]: Input,
      [Select.name]: Select,
      [TimePicker.name]: TimePicker,
      PSwitch
      // GeneralTopBar
    },
    props: {
      defaultData: {
        type: Object,
        default: () => ({})
      },
      modeldata: {
        type: Object,
        default: () => ({})
      },
      referalModel: {
        type: Object,
        default: () => ({})
      }
    },
    watch: {
      defaultData (value) {
        this.defaults = value
      },
      modeldata: {
        immediate: true,
        handler (value) {
          this.applyModelData(value)
        }
      },
      'model.loyalty_value_one_currency_per_days': {
        deep: true,
        handler () {
          this.forceUpdateTimePicker()
        }
      }
    },
    data () {
      return {
        arrayWithDays: {
          'Mon': false,
          'Tue': false,
          'Wed': false,
          'Thu': false,
          'Fri': false,
          'Sat': false,
          'Sun': false
        },
        arrayWithDaysTime: {
          'Mon': false,
          'Tue': false,
          'Wed': false,
          'Thu': false,
          'Fri': false,
          'Sat': false,
          'Sun': false
        },
        selectedDay: [],
        model: {},
        defaults: this.value || this.defaultData, // this.countries
        modelValidations: {
          loyalty_value_one_point: { required: true },
          loyalty_value_one_point_amount: { required: true },
          loyalty_value_one_currency: { required: true },
          loyalty_min_order_value: { decimal: 2, min_value: 0, max_value: 99999999.99 }
        },
        timePickerKey: []
      }
    },
    computed: {
      currency () {
        const company = this.model || {}
        const details = company.price_details || {}
        if (details.symbol) return this.decodeHtml(details.symbol)
        if (company.currency_iso) return company.currency_iso

        const selectedCompany = this.$session.get('selectedCompanyData') || {}
        const cachedDetails = selectedCompany.price_details || {}
        return cachedDetails.symbol ? this.decodeHtml(cachedDetails.symbol) : (selectedCompany.currency_iso || '')
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.saveDetails()
          }
        })
      },
      handleErrors (errors) {
        for (var prop in errors) {
          if (errors.hasOwnProperty(prop)) {
            this.errors.add(prop, errors[prop][0])
          }
        }
      },
      applyModelData (value) {
        if (!value || typeof value !== 'object' || Array.isArray(value) || !Object.keys(value).length) {
          return
        }
        const data = Object.assign({}, value)
        if (data.loyalty_value_one_point_amount != null && data.loyalty_value_one_point_amount !== '') {
          data.loyalty_value_one_point_amount = Math.round(data.loyalty_value_one_point_amount * 10) / 10
        }
        Object.keys(this.arrayWithDays).forEach((day) => {
          this.arrayWithDays[day] = false
          this.arrayWithDaysTime[day] = false
        })
        if (data.loyalty_value_one_currency_per_days && typeof data.loyalty_value_one_currency_per_days === 'object') {
          for (var day in data.loyalty_value_one_currency_per_days) {
            const dayData = data.loyalty_value_one_currency_per_days[day]
            if (!dayData || typeof dayData !== 'object') {
              continue
            }
            this.arrayWithDays[day] = true
            if (dayData.from) {
              this.arrayWithDaysTime[day] = true
            }
          }
        }
        if (data.loyalty_min_order_value === undefined) {
          data.loyalty_min_order_value = null
        }
        data.loyalty_only_full_points = this.isLoyaltyInUseEnabled(data.loyalty_only_full_points)
        data.loyalty_in_use = this.isLoyaltyInUseEnabled(data.loyalty_in_use)
        this.model = data
      },
      saveDetails () {
        var companyID = this.$session.get('selectedCompany')
        var data = {
          'token': this.$session.get('token'),
          'loyalty_value_one_currency': this.model.loyalty_value_one_currency,
          'loyalty_only_full_points': this.model.loyalty_only_full_points === true || this.model.loyalty_only_full_points === 1 || this.model.loyalty_only_full_points === '1' ? 1 : 0,
          'loyalty_min_order_value': this.model.loyalty_min_order_value === '' || this.model.loyalty_min_order_value == null
            ? null
            : Number(this.model.loyalty_min_order_value),
          'loyalty_value_one_point_amount': this.model.loyalty_value_one_point_amount,
          'loyalty_value_one_point': this.model.loyalty_value_one_point,
          'loyalty_value_one_currency_per_days': this.model.loyalty_value_one_currency_per_days,
          'donation_point_value': parseFloat(this.model.donation_point_value),
          'loyalty_points_use_limit': this.model.loyalty_points_use_limit !== null && this.model.loyalty_points_use_limit !== ''
            ? parseInt(this.model.loyalty_points_use_limit, 10)
            : null
        }
        var self = this
        if (typeof this.saveReferal === 'function') {
          this.saveReferal()
        }
        this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
          if (response.status === true) {
            swal({'text': self.$t('settingsRewards.rewardSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
            self.updateSelectedCompanyCache(response.data[0])
          } else {
            self.handleErrors(response.errors)
          }
        })
      },
      isLoyaltyInUseEnabled (value) {
        return value === true || value === 1 || value === '1' || value === 'true'
      },
      normalizeCompanyCacheData (companyData) {
        if (!companyData) return companyData
        const cached = Object.assign({}, companyData)
        cached.loyalty_in_use = this.isLoyaltyInUseEnabled(cached.loyalty_in_use)
        return cached
      },
      updateSelectedCompanyCache (companyData) {
        if (!companyData) return
        const cached = this.normalizeCompanyCacheData(companyData)
        this.$session.set('selectedCompanyData', cached)
        this.$bus.$emit('company-data-updated', cached)
      },
      handleActive (e) {
        var companyID = this.$session.get('selectedCompany')
        var data = {
          'token': this.$session.get('token'),
          'loyalty_in_use': this.isLoyaltyInUseEnabled(this.model.loyalty_in_use)
        }
        // let actionText = this.model.loyalty_in_use ? 'enabled' : 'disabled'
        var self = this
        this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
          if (response.status === true) {
            swal({'text': self.$t('settingsRewards.rewardSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
            self.updateSelectedCompanyCache(response.data[0])
          } else {
            self.handleErrors(response.errors)
            self.model.loyalty_in_use = !self.model.loyalty_in_use
            swal(
              '',
              response.errors['id'] ? response.errors['id'] : self.$t('validations.wentWrong'),
              'error'
            )
          }
        })
      },
      handleNotification (e) {
        var companyID = this.$session.get('selectedCompany')
        var data = {
          'token': this.$session.get('token'),
          'enable_notification_loyalty_points': this.model.enable_notification_loyalty_points ? 1 : 0
        }
        // let actionText = this.model.loyalty_in_use ? 'enabled' : 'disabled'
        var self = this
        this.apiRequest('/settings/general/' + companyID, 'PUT', data, function (response) {
          if (response.status === true) {
            swal({'text': self.$t('settingsRewards.rewardSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
            self.updateSelectedCompanyCache(response.data[0])
          } else {
            self.handleErrors(response.errors)
            self.model.enable_notification_loyalty_points = !self.model.enable_notification_loyalty_points
            swal(
              '',
              response.errors['id'] ? response.errors['id'] : self.$t('validations.wentWrong'),
              'error'
            )
          }
        })
      },
      goToSettings () {
        this.$session.set('selectedTab', this.$t('settingsPages.push'))
        this.$router.push('/settings')
      },
      clickOnCheckbox (day) {
        if (this.model.loyalty_value_one_currency_per_days == null || this.model.loyalty_value_one_currency_per_days.length === 0) {
          this.model.loyalty_value_one_currency_per_days = {}
          this.model.loyalty_value_one_currency_per_days[day] = {val: '', from: '', to: ''}
        }
        if (this.arrayWithDays[day]) {
          this.model.loyalty_value_one_currency_per_days[day] = {val: this.model.loyalty_value_one_currency, from: '', to: ''}
        } else {
          delete this.arrayWithDaysTime[day]
          delete this.model.loyalty_value_one_currency_per_days[day]
        }
      },
      setTimePeriod (day) {
        if (this.arrayWithDaysTime[day]) {} else {
          delete this.model.loyalty_value_one_currency_per_days[day].from
          delete this.model.loyalty_value_one_currency_per_days[day].to
        }
      },
      forceUpdateTimePicker () {
        if (this.arrayWithDaysTime) {
          Object.keys(this.arrayWithDaysTime).forEach((index) => {
            this.$set(this.timePickerKey, index, {from: 'from_' + index, to: 'to_' + index})
          })
        }
      },
      changeFrom () {
        this.forceUpdateTimePicker()
      }
    }
  }
</script>

<style lang="scss">
.days {
  display: flex;
  flex-direction: column;
  .day {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    .label {
      font-weight: 600;
      color: #25396F;
      margin-right: 5px;
      min-width: 50px;
      padding: .2em .6em .3em;
    }
    .dayField {
      margin-left: 20px;
      margin-right: 10px;
      font-size: 14px;
    }
  }
}
.card.moneyPoints {
    max-height: 600px;
    height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/RewardProgram/RewardProgramForm.vue